module.exports = __webpack_public_path__ + "img/202403_06.0e498a65.jpg";